import Cookies from 'universal-cookie'

// Resolve the VISCA bridge server address (same default used by LiveKit)
export const getViscaIP = () => {
  const cookies = new Cookies()
  return cookies.get('visca') || 'http://localhost:9131'
}

// Resolve a camera's VISCA IP, stored in a cookie keyed by its deviceId
export const getDeviceIP = (deviceId) => {
  const cookies = new Cookies()
  return cookies.get(deviceId)
}

// Reverse pan/tilt commands when the operator has flipped the axis in settings
export const applyFlip = (command) => {
  const cookies = new Cookies()
  const flipH = cookies.get('viscaFlipH') === true || cookies.get('viscaFlipH') === 'true'
  const flipV = cookies.get('viscaFlipV') === true || cookies.get('viscaFlipV') === 'true'
  if (flipH) {
    if (command === 'go left') return 'go right'
    if (command === 'go right') return 'go left'
  }
  if (flipV) {
    if (command === 'go up') return 'go down'
    if (command === 'go down') return 'go up'
  }
  return command
}

// POST a VISCA command to the bridge for a given camera IP
export const sendViscaCommand = (deviceIP, command) => {
  const viscaIP = getViscaIP()
  return fetch(viscaIP + '/visca', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ deviceIP, command: applyFlip(command) })
  })
}
